export const isEmptyArray = (array?: any[] | undefined): boolean =>
  !array || array.length === 0;
